// 📂 src/pages/Client/ClientProfilePage.tsx
import { useEffect } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import { useClientProfileDropdown } from '../../hooks/client/dropdown/useClientProfileDropdown';
import { useClientProfileSwitch } from '../../hooks/client/useClientProfileSwitch';
import ClientProfileCard from '../../components/Client/Table/Card/ClientProfileCard';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const ClientProfilePage = () => {
  const { clientProfileDropdown, fetchClientProfileDropdown } =
    useClientProfileDropdown();
  const { switchProfile } = useClientProfileSwitch();

  // 🔄 Cargar las opciones de perfil al montar
  useEffect(() => {
    fetchClientProfileDropdown();
  }, []);

  /**
   * ⚙️ Manejar cambio de perfil desde el selector
   */
  const handleProfileChange = async (newProfileId: number) => {
    console.log('🔁 Solicitando cambio de perfil a ID:', newProfileId);

    // ⚙️ Llamar al servicio para cambiar el perfil activo
    await switchProfile(newProfileId);
  };

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <ClientProfileCard
        profileOptions={clientProfileDropdown || []}
        onProfileChange={handleProfileChange}
      />
    </DefaultLayout>
  );
};

export default ClientProfilePage;
